// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4891) return "static/css/4891.a63b1c6639adec18e735.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2387":"0f38139ae2c98bbc615c","6877":"0f38139ae2c98bbc615c"}[chunkId] + ".chunk.css";
};